"use client";

import { useRef, useState, type RefObject } from "react";
import { Alert, Button } from "@softmax/design-system";
import * as stylex from "@stylexjs/stylex";
import { composerStyles } from "../forum-composer.styles";
import type { ForumCommentDeletion as Deletion } from "../forum.types";
export function ForumCommentDeletion({
  deletion,
  canDelete,
  commentId,
  commentRoot,
}: Readonly<{
  deletion: Deletion | undefined;
  canDelete: boolean | undefined;
  commentId: string;
  commentRoot: RefObject<HTMLElement | null>;
}>) {
  const [confirmDelete, setConfirmDelete] = useState(false);
  const deleteTrigger = useRef<HTMLButtonElement>(null);

  if (!deletion || !canDelete) return null;

  return (
    <div {...stylex.props(composerStyles.form)}>
      {confirmDelete ? (
        <div {...stylex.props(composerStyles.actions)}>
          <span>Delete this comment?</span>
          <Button
            size="sm"
            aria-disabled={deletion.busyId !== null}
            onClick={async () => {
              if (deletion.busyId !== null) return;

              const accepted = await deletion.onDelete(commentId);

              if (accepted) {
                setConfirmDelete(false);
                commentRoot.current?.focus();
              }
            }}
          >
            {deletion.busyId === commentId ? "Deleting…" : "Confirm delete"}
          </Button>
          <Button
            size="sm"
            aria-disabled={deletion.busyId !== null}
            onClick={() => {
              if (deletion.busyId !== null) return;

              setConfirmDelete(false);
              deleteTrigger.current?.focus();
            }}
          >
            Keep comment
          </Button>
        </div>
      ) : (
        <div {...stylex.props(composerStyles.actions)}>
          <Button
            ref={deleteTrigger}
            size="sm"
            variant="quiet"
            aria-disabled={deletion.busyId !== null}
            onClick={() => {
              if (deletion.busyId === null) setConfirmDelete(true);
            }}
          >
            Delete comment
          </Button>
        </div>
      )}
      {deletion.error?.id === commentId && (
        <Alert tone="danger" announcement="assertive">
          {deletion.error.message}
        </Alert>
      )}
    </div>
  );
}
